var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.videoId)?_c('div',{staticClass:"b-video"},[_c('base-video',{attrs:{"videoId":_vm.data.videoId,"cursorLabel":{ label: 'visionner', iconBefore: 'play' }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }